import React from "react";

// MATERIAL-UI
import { Grid, Box, Typography, Modal, SxProps, Theme, Stack, Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useIsMobile } from "src/utils/hooks/useIsMobile";
import { AddressTestingStyles } from "../../common/styles/AddressTesting.styles";
import clsx from "clsx";
const mobileStyle: SxProps<Theme> = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  bgcolor: "background.paper",
  borderRadius: "10px",
};

const desktopStyle: SxProps<Theme> = {
  position: "absolute",
  top: "50%",
  left: "50%",
  height: "auto",
  transform: "translate(-50%, -50%)",
  width: "500px",
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "10px",
  display: "flex",
  flexDirection: "column",
};

type CurrencyMemoModal = {
  name: string;
  icon?: string;
};
interface MemoModalProps {
  open: boolean;
  memo?: string;
  currency?: CurrencyMemoModal;
  onClose: (event: any) => void;
}

const MemoModal = (props: MemoModalProps) => {
  const { memo, currency } = props;
  // ---------------Sytles------------------------
  const classes = AddressTestingStyles();
  const isMobile = useIsMobile();
  const style = isMobile ? mobileStyle : desktopStyle;
  return (
    <Modal open={props.open} onClose={props.onClose}>
      <Box sx={style}>
        <Box
          className={clsx(classes.titleContainer, {
            [classes.titleContainerDesktop]: !isMobile,
          })}>
          <CloseIcon onClick={props.onClose} className={classes.closeIcon} />
          <Typography id="modal-title" variant="h6" component="h2">
            Memo
          </Typography>
          <div></div>
        </Box>
        <Grid item>
          <Stack direction="column" className={classes.memoContainer}>
            <Box className={classes.memoBox}>
              <Typography className={classes.memoTitle}>Currency</Typography>
              <Stack className={classes.memoBoxContainer} direction="row">
                <img alt="memo-img" className={classes.currencyIcon} src={currency?.icon} />
                <Typography variant="body1">{currency?.name}</Typography>
              </Stack>
            </Box>
            <Box className={classes.memoBox}>
              <Typography className={classes.memoTitle}>Memo</Typography>
              <Stack className={classes.memoBoxContainer} direction="column">
                <Typography variant="body1">{memo || "Loading"}</Typography>
              </Stack>
            </Box>
            <Button
              disableRipple
              onClick={() => navigator.clipboard.writeText(memo || "")}
              className={classes.nextBtn}>
              Copy Memo
            </Button>
          </Stack>
        </Grid>
      </Box>
    </Modal>
  );
};

export default MemoModal;
